/*! bxs-vue-ui v4.0.1 */
import { _ as _export, N as path } from './es.array.join.js';

// `Number.isNaN` method
// https://tc39.github.io/ecma262/#sec-number.isnan
_export({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

var isNan = path.Number.isNaN;

var isNan$1 = isNan;

var isNan$2 = isNan$1;

export { isNan$2 as i };
